import { FindClassificationTypesParams } from '../../../../services/modules/classificationTypes/classificationTypes.types';
import { ClassificationTypeEntityEnum } from '../../../classifications/classification.types';

export const validateFindClassificationTypesOfflineParams = (
  entity: FindClassificationTypesParams['entity'],
  useAsFilter: FindClassificationTypesParams['useAsFilter'],
): boolean => {
  return entity === ClassificationTypeEntityEnum.PRODUCT_COLOR && useAsFilter === true;
};
